import { Link } from 'react-router-dom';
import './footer.css';

export default function Footer() {
    return (
        <footer>
            <div className="footer-content">
                <div className="footer-sitemap">
                    <div className="sitemap-column">
                        <h3>
                            <Link to="/about">About Us</Link>
                        </h3>
                        <ul>
                            <li>
                                <Link to="/about#org-intro">
                                    About CHOPSTICKSTORY
                                </Link>
                            </li>
                            <li>
                                <Link to="/about#team-section">Our Team</Link>
                            </li>
                            <li>
                                <Link to="/project">Our Project</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="sitemap-column">
                        <h3>
                            <Link to="/programs">Programs</Link>
                        </h3>
                        <ul>
                            <li>
                                <Link to="/programs#chopsticks">Chopsticks</Link>
                            </li>
                            <li>
                                <Link to="/programs#lotus-lantern">
                                    Lotus Lantern
                                </Link>
                            </li>
                            <li>
                                <Link to="/programs#dancheong">Dancheong</Link>
                            </li>
                            <li>
                                <Link to="/programs#k-archery">K-Archery</Link>
                            </li>
                            <li>
                                <Link to="/programs#hanji-lantern">
                                    Hanji Lantern
                                </Link>
                            </li>
                            <li>
                                <Link to="/programs#mother-of-pearl">
                                    Mother-of-Pearl
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="sitemap-column">
                        <h3>Connect</h3>
                        <ul>
                            <li>
                                <a href="mailto:info@chopstickstory.org">
                                    Contact Us
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.paypal.com/donate/?hosted_button_id=WZK3AX6WV9RMC"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Donate
                                </a>
                            </li>
                            <li>
                                <Link to="/privacy">Privacy Policy</Link>
                            </li>
                            <li>
                                <Link to="/terms">Terms of Service</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-grid">
                    <div className="org-info">
                        <h3>CHOPSTICKSTORY</h3>
                        <p>
                            A 501(c)(3) nonprofit organization | EIN:
                            99-0860654 | Address: Cupertino, CA | Phone: (607)
                            973-0750 | Email: info@chopstickstory.org
                        </p>
                    </div>
                </div>
                <div className="copyright">
                    <p>&copy; 2025 CHOPSTICKSTORY. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
